import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from 'src/service/language-management.service';
import { CommunicationTemplate, KeyValueId, KeyValues3, LocalService, Status } from 'src/service/local.service';
import { ProfileManagementService } from 'src/service/profile-management.service';

@Component({
  selector: 'app-send-to-phone',
  templateUrl: './send-to-phone.component.html',
  styleUrl: './send-to-phone.component.scss'
})
export class SendToPhoneComponent {
  lstSectionConfigKeys: string[] = ["send_to_phone"];
  @Input() key: string = '';
  @Input() header: string = '';
  @Input() communicationTemplate: CommunicationTemplate = CommunicationTemplate.None;

  @Input() isOpen: boolean = false;
  @Output() isOpenChange = new EventEmitter();
  @Output() onSent = new EventEmitter();
  @Input() isChildPopupOpened = false;
  @Input() isHiddenProcess = false;
  @Input() returnDataOnSuccess: any;

  contactNumbers: string[] = []; isShowMappingNumbers: boolean = false;
  message: string = ''; languagesEquivalent: KeyValues3[] = []; countryCode: string = '';

  htmlId: string = ''; elementIds: any; printingLanguage = ''; printerTemplateIds: string[] = []; receiptTemplateItems: KeyValueId[] = [];

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private profileManagementService: ProfileManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      dd_print_language: 'dd_print_language_' + this.htmlId
    }
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.countryCode = this.localService.selected.countryCode;
    this.printingLanguage = this.localService.selected.applicationLanguage;
    this.languagesEquivalent = this.localService.Sort(this.localService.languagesEquivalent, true, 'v3')
    this.onLoad();
  }

  onLoad() {
    this.onLoadReceiptTemplates();
    this.message = '';
    this.onGetDefaultContactNumbers();
  }

  close() {
    this.isOpen = false;
    this.isOpenChange.emit(this.isOpen);
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.close();
      } break;
      case 2: {
        this.onSendMessage();
      } break;
    }
  }

  onGetDefaultContactNumbers() {
    this.isShowMappingNumbers = false;
    this.profileManagementService.getDefautContactNumbersToSend(this.communicationTemplate, this.key).subscribe(result => {
      this.contactNumbers = result;
      this.isShowMappingNumbers = true;
      if (this.isHiddenProcess) {
        this.onSendMessage();
      }
    });
  }

  onSendMessage() {
    this.printerTemplateIds = this.receiptTemplateItems.filter(x => x.isSelected == true).map(x => x.key);

    this.profileManagementService.sendMessageToPhone(this.communicationTemplate, this.key, this.contactNumbers, this.printingLanguage, this.printerTemplateIds).subscribe(result => {
      switch (result.status) {
        case Status.Success: {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onSent.emit(this.returnDataOnSuccess);
            this.close();
          }
        } break;
        default: {

          switch (result.status) {
            case Status.DataRequired: {
              this.isHiddenProcess = false;
              this.isShowMappingNumbers = false;
              setTimeout(() => {
                this.isShowMappingNumbers = true;
              }, 0);
              this.message = this.localService.languageContent.send_to_phone.data_required;
            } break;
            case Status.InventoryRequired: {
              this.message = this.localService.languageContent.send_to_phone.no_credits;
            } break;
            default: {
              this.message = this.localService.getTextByStatus(result.status);
            } break;
          }

          if (this.isHiddenProcess) {
            this.localService.showInformation(this.message, true);
            this.close();
          }
        } break;
      }
    });
  }

  onValuesUpdated(values: any) {
    this.message = '';
    this.contactNumbers = values;
  }

  onLoadReceiptTemplates() {
    const customerTemplateIds = this.localService.getCustomerCopiesTemplateIds();
    customerTemplateIds.forEach(customerTemplateId => {
      const template = this.localService.loggedMember.receiptTemplates.find(x => x.id == customerTemplateId);

      if (template) {
        this.receiptTemplateItems.push({
          key: template.id,
          value: template.title,
          isSelected: false
        });
      }
    });

    if (this.receiptTemplateItems.length > 0) {
      this.receiptTemplateItems[0].isSelected = true;
    }
  }
}
